import { motion } from "motion/react";
import { LayoutTextFlip } from "./ui/layout-text-flip";
import { useTranslations } from "next-intl";

export default function WordFlipper() {
    const t = useTranslations("wordFlippers");

    const milsatInsights = [
        // Education Infrastructure - AMAC
        { insight: t("i1"), tag: t("tags.AMAC") },
        { insight: t("i2"), tag: t("tags.AMAC") },
        { insight: t("i3"), tag: t("tags.AMAC") },
        { insight: t("i4"), tag: t("tags.AMAC") },
        { insight: t("i5"), tag: t("tags.AMAC") },
        { insight: t("i6"), tag: t("tags.AMAC") },

        // Energy Infrastructure - AMAC
        { insight: t("i7"), tag: t("tags.AMAC") },
        { insight: t("i8"), tag: t("tags.AMAC") },

        // Fuel & Gas Infrastructure - AMAC
        { insight: t("i9"), tag: t("tags.AMAC") },
        { insight: t("i10"), tag: t("tags.AMAC") },
        { insight: t("i11"), tag: t("tags.AMAC") },
        { insight: t("i12"), tag: t("tags.AMAC") },

        // Veterinary Services - FCT
        { insight: t("i13"), tag: t("tags.FCT") },
        { insight: t("i14"), tag: t("tags.FCT") },
        { insight: t("i15"), tag: t("tags.FCT") },
        { insight: t("i16"), tag: t("tags.FCT") },

        // Business Registration
        { insight: t("i17"), tag: t("tags.General") },

        // FUTA Off-Campus Residential Distribution
        { insight: t("i18"), tag: t("tags.FUTA") },
        { insight: t("i19"), tag: t("tags.FUTA") },
        { insight: t("i20"), tag: t("tags.FUTA") },

        // South Gate Specific - FUTA
        { insight: t("i21"), tag: t("tags.South Gate") },
        { insight: t("i22"), tag: t("tags.South Gate") },
        { insight: t("i23"), tag: t("tags.South Gate") },
        { insight: t("i24"), tag: t("tags.South Gate") },

        // Electricity Metering - North Gate
        { insight: t("i25"), tag: t("tags.North Gate") },

        // Security Status - South Gate
        { insight: t("i26"), tag: t("tags.South Gate") },
        { insight: t("i27"), tag: t("tags.South Gate") },
        { insight: t("i28"), tag: t("tags.South Gate") },
        { insight: t("i29"), tag: t("tags.South Gate") },
        { insight: t("i30"), tag: t("tags.South Gate") },

        // Electricity Supply - North Gate
        { insight: t("i31"), tag: t("tags.North Gate") },
        { insight: t("i32"), tag: t("tags.North Gate") },
        { insight: t("i33"), tag: t("tags.North Gate") },
        { insight: t("i34"), tag: t("tags.North Gate") },
        { insight: t("i35"), tag: t("tags.North Gate") },

        // Grid Power - South Gate
        { insight: t("i36"), tag: t("tags.South Gate") },
        { insight: t("i37"), tag: t("tags.South Gate") },
        { insight: t("i38"), tag: t("tags.South Gate") },
        { insight: t("i39"), tag: t("tags.South Gate") }
    ];
    return <>
        <motion.div className="relative mx-4 my-4 flex flex-col items-center justify-center gap-4 text-center sm:mx-0 sm:mb-0 sm:flex-row">
            <LayoutTextFlip
                text=""
                words={milsatInsights}
            />
        </motion.div>
    </>
}